import { useQuery } from '@tanstack/react-query';
import { useOrganizationsService } from '@restworld/data-services';
import { useAuth } from '@restworld/feature-authentication';

interface UseCheckInvoiceStatusParams {
  organizationId?: string;
  enabled?: boolean;
}

export const useCheckInvoiceStatus = ({ organizationId, enabled = true }: UseCheckInvoiceStatusParams = {}) => {
  const organizationsService = useOrganizationsService();
  const { user } = useAuth();

  const query = useQuery({
    queryKey: ['invoice-status', organizationId],
    queryFn: async () => {
      if (!organizationId) {
        throw new Error('Organization ID is required');
      }

      const { data } = await organizationsService.checkInvoicesStatus({
        organizationId,
      });

      return data;
    },
    enabled: enabled && !!organizationId && user?.using_ppu_business_model === true,
    staleTime: 0, // Always consider data stale
    gcTime: 0, // Don't cache the result
    retry: false, // Don't retry failed requests
    refetchOnMount: 'always', // Always refetch when component mounts
  });

  return {
    isChecking: query.isLoading,
    data: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    refetch: query.refetch,
  };
};
